import { defineStore, acceptHMRUpdate } from 'pinia'
import { unref } from 'vue'
import useState from './useState'
import useActions from './useActions'

export const useFavGroupStore = defineStore('favGroups', () => {
  const state = useState()
  const store = {
    initialState: unref(state),
    ...state,
    ...useActions(state)
  }
  return store
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFavGroupStore, import.meta.hot))
}
